// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
/**
 * The Intl locale of a portal language: the portals name Catalan "cat" and
 * Tagalog "tl", which Intl knows as "ca" and "fil".
 */
export var intlLocale = function (language) {
    var base = (language || "en").split("-")[0];
    if (base === "cat")
        return "ca";
    if (base === "tl")
        return "fil";
    return language || "en";
};
/** A count written the way the viewer's language writes numbers. */
export var formatCount = function (value, language) {
    try {
        return new Intl.NumberFormat(intlLocale(language)).format(value);
    }
    catch (_a) {
        return String(value);
    }
};
/** [`formatCount`] in the portal's current language. */
export var useFormatCount = function () {
    var i18n = useTranslation().i18n;
    var language = i18n === null || i18n === void 0 ? void 0 : i18n.language;
    return useCallback(function (value) { return formatCount(value, language); }, [language]);
};
